import { TStandingType } from '../../../store/admin/eventAwards/store';

export const formattedStandingTotal = (standingType: TStandingType, total: number) =>
  `${standingType === 'cash' || standingType === 'scrip' ? '$' : ''}${
    standingType === 'cash' || standingType === 'scrip' ? total.toFixed(2) : total
  }`;
